import React from "react";

const LoadingButton = ({
  loading,
  text = "Submit",
  loadingText = "Processing...",
  className = "",
  ...props
}) => {
  return (
    <button
      disabled={loading}
      className={`flex items-center justify-center gap-2 px-4 py-2 rounded 
        disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {loading ? (
        <>
          <i className="fas fa-spinner fa-spin"></i>
          {loadingText}
        </>
      ) : (
        text
      )}
    </button>
  );
};

export default LoadingButton;
